import { PREVIEW_2_ADTYPES, PREVIEW_2_URL, TIA_DOMAIN, TIA_DOMAIN_PUBLIC, LEGACY_PREVIEW_ADTYPES } from "utils/constants";

function isLegacyPreview(dependentValues = {}, forceNew = false) {
	const { adType, origin } = dependentValues;
	return !forceNew && origin !== "after_effects" && origin !== "imposium" && !PREVIEW_2_ADTYPES.includes(adType) || LEGACY_PREVIEW_ADTYPES.includes(adType);
}

const PreviewCreativeNew = {
	basic(creativeId){
		// These are the previews used in iframes, without the Preview App UI components
		return `${PREVIEW_2_URL}/basic/${creativeId}`;
	},
	private(creativeId){
		return `${PREVIEW_2_URL}/creative/${creativeId}`;
	},
	multi(creativeIds){
		return `${PREVIEW_2_URL}/creative/${creativeIds.join(',')}`;
	},
	allVersions(creativeId){
		return `${PREVIEW_2_URL}/creative-versions/${creativeId}`;
	},
	public(publicId) {
		return `${PREVIEW_2_URL}/p/${publicId}`;
	},
};

const PreviewCreativeLegacy = {
	basic(creativeId){
		return `${TIA_DOMAIN}/basic/${creativeId}`;
	},
	private(creativeId){
		return `${TIA_DOMAIN}/tia/${creativeId}`;
	},
	allVersions(creativeId){
		return `${TIA_DOMAIN}/preview/${creativeId}`;
	},
	public(publicId) {
		return `${TIA_DOMAIN_PUBLIC}/p/${publicId}`;
	},
};

export const PreviewCreative = new Proxy(PreviewCreativeNew, {
	get: (target, prop) => {
		if (prop === 'new') {
			return target;
		}
		if (prop === 'legacy') {
			return PreviewCreativeLegacy;
		}
		return (creative, forceNew) => {
			const isLegacy = isLegacyPreview(creative, forceNew);
			const url = isLegacy ? PreviewCreativeLegacy[prop](creative.id) : target[prop](creative.id);
			return { url, isLegacy };
		};
	},
});

const PreviewVersionNew = {
	basic(creativeId, versionName){
		// These are the previews used in iframes, without the Preview App UI components
		return `${PREVIEW_2_URL}/basic/${creativeId}?selectedVersion=${versionName}`;
	},
	private(creativeId, versionName){
		return `${PREVIEW_2_URL}/creative/${creativeId}?panel=versions&selectedVersion=${versionName}`;
	},
	public(publicId) {
		return `${PREVIEW_2_URL}/pv/${publicId}`;
	},
};

const PreviewVersionLegacy = {
	basic(creativeId, versionName){
		return `${TIA_DOMAIN}/basic/${creativeId}?configurationName=${versionName}`;
	},
	private(creativeId, versionName){
		return `${TIA_DOMAIN}/tia/${creativeId}?configurationName=${versionName}`;
	},
	public(publicId) {
		return `${TIA_DOMAIN_PUBLIC}/pv/${publicId}`;
	},
};

export const PreviewVersion = new Proxy(PreviewVersionNew, {
	get: (target, prop) => {
		if (prop === 'new') {
			return target;
		}
		if (prop === 'legacy') {
			return PreviewVersionLegacy;
		}
		return (creative, versionName, forceNew) => {
			const force = prop === 'public' ? versionName : forceNew;
			const isLegacy = isLegacyPreview(creative, force);
			const url = isLegacy ? PreviewVersionLegacy[prop](creative.id, versionName) : target[prop](creative.id, versionName);
			return { url, isLegacy };
		};
	},
});
